import logoutLogger from "./logoutLogger";
import { DASHBOARD_VERSION } from "./appVersion";

// Wrap a promise with a timeout so a hung wallet disconnect (e.g. the
// extension was disabled or the WalletConnect relay is unreachable) can
// never block the rest of the logout flow.
const withTimeout = (promise, ms, label) =>
    Promise.race([
        promise,
        new Promise((resolve) =>
            setTimeout(() => {
                logoutLogger.log(`[performLogout] ${label} timed out after ${ms}ms - continuing`);
                resolve();
            }, ms)
        ),
    ]);

/**
 * Full logout flow shared by the sidebar and the topbar user menu.
 * Order: Privy logout (bounded) -> storage wipe -> manualLogout flag -> redux logout.
 * Privy's session is dropped too, so the login page does not sign the same
 * identity straight back in.
 */
const performLogout = async ({ privyLogout, dispatch, logout }) => {
    try {
        logoutLogger.log("=== LOGOUT FLOW STARTED ===");

        if (typeof privyLogout === "function") {
            await withTimeout(
                Promise.resolve()
                    .then(() => privyLogout())
                    .catch((e) => logoutLogger.log("Privy logout error:", e?.message)),
                4000,
                "privyLogout"
            );
        }

        // Wipe everything, then restore the two keys that must survive a
        // logout: the manualLogout flag (blocks auto sign-in) and the dashboard
        // version stamp (otherwise the next boot-time version check wipes the
        // fresh session and bounces the user back to /login).
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem("manualLogout", "true");
        localStorage.setItem("dashboardVersion", DASHBOARD_VERSION);

        dispatch(logout());
        logoutLogger.log("✅ Logout complete");
    } catch (error) {
        logoutLogger.log("ERROR during logout", { error: error.message, stack: error.stack });
        localStorage.clear();
        sessionStorage.clear();
        sessionStorage.setItem("manualLogout", "true");
        localStorage.setItem("dashboardVersion", DASHBOARD_VERSION);
        dispatch(logout());
    }
};

export default performLogout;
